module.exports = __webpack_public_path__ + "static/assets/97a1c4a111c5566075f074188ac23aa0.svg";